import { Box, Button, Container, Divider, IconButton } from "@mui/material";
import img_qaztrade_logo from "../../../assets/img/qaztrade_logo_big.png";
import img_logout from "../../../assets/img/log-out-01.svg";
import { UserType, auth } from "service";
import { useNavigate, Link } from "react-router-dom";
// import { PUBLIC_URL } from "config";

export const Header = () => {
  const navigate = useNavigate();
  return (
    <>
      <Container
        sx={{
          py: "12px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Link to={"/"}>
            <Box component={"img"} src={img_qaztrade_logo} height={"48px"} />
          </Link>
          <Box display={"flex"} gap={"8px"}>
            <Link to="/">
              <Button size="small" variant="contained">
                Заявления
              </Button>
            </Link>
            {auth.IsUserType(UserType.Manager) && (
              <Link to={"/manager/assignments"}>
                <Button size="small" variant="contained">
                  Мои задачи
                </Button>
              </Link>
            )}
            {auth.IsUserType(UserType.Admin) && (
              <Link to={"/admin/assignments"}>
                <Button size="small" variant="contained">
                  Панель задач
                </Button>
              </Link>
            )}
          </Box>
          <IconButton
            sx={{ p: "10px", height: "fit-content", borderRadius: "6px" }}
            onClick={() => {
              auth.LogOut();
              navigate("/auth/signin");
            }}
          >
            <Box
              component={"img"}
              src={img_logout}
              height={"20px"}
              width={"20px"}
            />
          </IconButton>
        </Box>
      </Container>
      <Divider />
    </>
  );
};
